/* Procurement tour -- 5 steps. Supplier + inventory focus. */
export default {
  role: "PROCUREMENT",
  steps: [
    {
      id: "proc-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.proc.welcome.title", titleFallback: "Welcome, {name}",
      bodyKey: "tour.proc.welcome.body", bodyFallback: "Quick tour of your surface: suppliers, inventory, tasks and chat. ~2 minutes.",
      side: "bottom",
    },
    {
      id: "proc-suppliers",
      route: "/suppliers",
      selector: '[data-tour-id="suppliers-page"]',
      titleKey: "tour.proc.suppliers.title", titleFallback: "Suppliers directory",
      bodyKey: "tour.proc.suppliers.body", bodyFallback: "All vendors in one place. Add contacts, track leadtime and price history.",
      side: "top",
      optional: true,
    },
    {
      id: "proc-inventory",
      route: "/inventory",
      selector: '[data-tour-id="inventory-page"]',
      titleKey: "tour.proc.inventory.title", titleFallback: "Inventory",
      bodyKey: "tour.proc.inventory.body", bodyFallback: "Stock levels + movements. Reorder alerts fire automatically when stock dips below the reorder point.",
      side: "top",
      optional: true,
    },
    {
      id: "proc-tasks",
      route: "/tasks",
      selector: '[data-tour-id="my-tasks-page"]',
      titleKey: "tour.proc.tasks.title", titleFallback: "Your tasks",
      bodyKey: "tour.proc.tasks.body", bodyFallback: "Follow-ups on quotes, RFQs, PO chases. All in one board.",
      side: "top",
    },
    {
      id: "proc-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.proc.replay.title", titleFallback: "Replay anytime",
      bodyKey: "tour.proc.replay.body", bodyFallback: "This header button re-launches the tour when you need a refresher.",
      side: "bottom",
    },
  ],
};
